import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import Nav from '../../components/Nav/Nav';
import ratedPeople from '../assets/herosectionimage.png';
import smallRatedPeople from '../assets/herosectionimage.png';
import CountrySelector from './CountrySelector';
import CategorySelector from './CategorySelector';
import VendorSelector from './VendorSelector';
import search_icon from '../assets/search.svg';
import Footer from '../../components/Footer/Footer';
import Review from '../../components/Review/Review';
import CreateAccountModal from '../../components/CreateAccountModal/CreateAccountModal';
import { useNavigate } from 'react-router-dom';
import errorIcon from '../../components/assets/error.svg';
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';
import StarRating from '../../components/Starrating';
import HowToRate from '../../components/HowToRate';
import { ChevronLeft } from "lucide-react";
import { ChevronRight } from "lucide-react";

const Home = ({ reviewData, vendorCountryData, categoryData, vendorData }) => {
  const [country, setCountry] = useState('');
  const [category, setCategory] = useState('');
  const [vendor, setVendor] = useState('');
  const [createAccount, setCreateAccount] = useState(null);
  const navigate = useNavigate();
  const [searchError, setSearchError] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(null);

  // To keep track of filtered options
  const [filteredVendors, setFilteredVendors] = useState(vendorData);
  const [filteredCountries, setFilteredCountries] = useState(vendorCountryData);
  const [filteredCategories, setFilteredCategories] = useState(categoryData);

  // Function that returns how many reviews to show per page based on screen size
   const getPerPage = () => {
  const w = window.innerWidth;
  if (w < 744) return 3;       // mobile
  if (w < 1024) return 4;      // tablet
  return 6;                     // desktop
};

  const [perPage, setPerPage] = useState(getPerPage()); // how many items to show per page based on screen width
  const [currentPage, setCurrentPage] = useState(1); //  controls which page is currently selected
  const [showPagination, setShowPagination] = useState(false); // determines if pagination UI should be visible

  const [hasShownMore, setHasShownMore] = useState(false); // State: tracks if the "show more" button has already been clicked
  

  // Function to handle vendor selection and automatically filter categories and countries
  const handleVendorSelect = (selectedVendor, vendor_id) => {
    setVendor(selectedVendor);

    // Filter categories and countries based on selected vendor
    const vendorCategories = vendorData.filter(v => v.vendor_name === selectedVendor)
      .map(v => v.category.category_name);
    const vendorCountries = vendorData.filter(v => v.vendor_name === selectedVendor)
      .map(v => v.vendor_country.vendor_country_name);

    //setFilteredCategories(categoryData.filter(c => vendorCategories.includes(c.category_name)));
    // setFilteredCountries(vendorCountryData.filter(c => vendorCountries.includes(c.vendor_country_name)));
  };
  // Function to handle category selection and automatically filter vendors and countries
  const handleCategorySelect = (selectedCategory) => {
    setCategory(selectedCategory);

    // Start filtering vendors by category
    let categoryVendors = vendorData.filter(v => v.category.category_name === selectedCategory);

    // If a country is selected, filter vendors by both country and category
    if (selectedCountry) {
      categoryVendors = categoryVendors.filter(v => v.vendor_country.vendor_country_name === selectedCountry);
    }

    // Get unique country names for filtered vendors
    const categoryCountryNames = [...new Set(categoryVendors.map(v => v.vendor_country.vendor_country_name))];
    const categoryCountries = vendorCountryData.filter(v => categoryCountryNames.includes(v.vendor_country_name));

    setFilteredVendors(categoryVendors);
    //setFilteredCountries(categoryCountries);
  };

  // Function to handle country selection and automatically filter vendors and categories
  const handleCountrySelect = (selectedCountry) => {
    setSelectedCountry(selectedCountry); // Store selected country in state
    setCountry(selectedCountry);

    // Filter vendors based on the selected country
    const countryVendors = vendorData.filter(v => v.vendor_country.vendor_country_name === selectedCountry);

    // Get unique category names for vendors in the selected country
    const countryCategoryNames = [...new Set(countryVendors.map(v => v.category.category_name))];

    // Filter categories based on selected country
    const countryCategories = categoryData.filter(c => countryCategoryNames.includes(c.category_name));

    setFilteredVendors(countryVendors);
    // setFilteredCategories(countryCategories);
  };



  // Handle Search functionality
  const handleSearch = () => {
    if (vendor?.length < 1 && category?.length < 1 && country?.length < 1) {
      setSearchError('Invalid Search');
      return;
    } else if (vendor?.length < 1) {
      setSearchError('Vendor is Required');
      return;
    } else if (category?.length < 1 && country?.length < 1) {
      setSearchError('Category or Country is Required');
      return;
    }

    let filterSearchedVendor = vendorData;
    if (vendor?.length > 0) {
      filterSearchedVendor = filterSearchedVendor?.filter(vendorItem =>
        vendorItem?.vendor_name?.toLowerCase()?.includes(vendor?.toLowerCase())
      );
    }

    if (category?.length > 0) {
      filterSearchedVendor = filterSearchedVendor?.filter(vendorItem =>
        vendorItem?.category?.category_name?.toLowerCase()?.includes(category?.toLowerCase())
      );
    }

    if (country?.length > 0) {
      filterSearchedVendor = filterSearchedVendor?.filter(vendorItem =>
        vendorItem?.vendor_country?.vendor_country_name?.toLowerCase()?.includes(country?.toLowerCase())
      );
    }

    if (filterSearchedVendor.length === 0) {
      setSearchError('No vendors found for the given search criteria.');
    } else {
      setSearchError('');
      // Assuming filterSearchedVendor contains only one vendor data point
      const vendorId = filterSearchedVendor[0]?.vendor_id; // Extract vendor_id from filterSearchedVendor

      // Filter reviewData based on the vendor_id
      const filteredVendorData = reviewData.filter(review => review.vendor.vendor_id === vendorId);

      navigate('/vendor', { state: { vendor: filterSearchedVendor[0], filteredVendorData: filteredVendorData } });
    }
  };

  // Decode the data 
  function decodeData(data) {
    return atob(data); // Base64 encoding
  }

  // Function to update the perPage value whenever the screen resizes
  useEffect(() => {
  const handleResize = () => {
    setPerPage(getPerPage());
  };

  window.addEventListener("resize", handleResize); // Add resize event listener
  return () => window.removeEventListener("resize", handleResize);  // remove event listener when component unmounts
}, []);


  useEffect(() => {
    const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
    const decodedToken = storeToken ? decodeData(storeToken) : null;
    const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
    if (userInfo) {
      navigate('/dashboard');
    }
  }, [navigate]);

  useEffect(() => {
    setFilteredCountries(vendorCountryData)
    setFilteredCategories(categoryData)
    setFilteredVendors(vendorData)
  }, [vendorCountryData, categoryData, vendorData])

  const sortedReviews = [...reviewData].sort((a, b) => b.feedback_id - a.feedback_id);
  const displayedReviews = sortedReviews.slice(
  (currentPage - 1) * perPage,
  currentPage * perPage
);



  return (
    <div className='overflow-x-hidden '>
      <Nav />
      {
        createAccount ? <CreateAccountModal setCreateAccount={setCreateAccount} /> : null
      }
      <div className='relative   w-full flex flex-col gap-[50px] bg-custom-gradient h-[770px] md:h-[500px] lg:h-[625px] xl:h-[854px]'>
        <div className='  '>

          <div className='flex flex-col items-center md:items-start text-center xl:justify-end md:flex-row gap-[30px]'>
            <img src={ratedPeople} alt="ratedpeople" className='absolute  md:-top-[320px] md:block lg:-top-[310px] xl:-top-[470px] md:right-1  lg:right-2 xl:right-[73px] hidden md:w-[434px] md:h-auto lg:w-[497px] xl:min-w-[641px] ' />
            <img src={smallRatedPeople} alt="smallRatedPeople" className='absolute top-[184px] max-w-[300px] h-auto flex md:hidden' />
            <div className='absolute w-full top-[124px]  md:top-[146px] md:left-[32px] lg:right-[127px] lg:top-[176px] xl:top-[219px] mg:left-[64px] flex flex-col gap-2 text-white text-center md:mt-[0px] md:w-[374px]  lg:w-[545px] xl:w-[801px] md:text-start pt-[0px]'>
              <div className='flex justify-center items-center md:justify-start mb:[0px] md:mb-[14px]'>
                <StarRating rating={4} />
              </div>
              {/* <h1 className=' w-full font-black text-center md:text-start px-[24px] md:px-0 text-xl lg:text-huge xl:text-hb'>See what others are saying about your favourite vendors</h1>
              <p className=' font-medium text-sm mg:text-lg px-[49px] md:px-0 '>Discover honest, unbiased reviews to help you make informed choices.</p> */}
              <h1 className='w-full font-black text-center md:text-start px-9 md:px-0 text-[24px] lg:text-huge xl:text-[40px]'>
                The smart way to book reliable vendors for every event.
              </h1>
              <p className='font-medium text-sm  px-[16px] md:px-0'>
                Find trusted professionals backed by real reviews - or grow your business with us

              </p>
              {/**Error Display */}
              {searchError !== "" ? (
                <div className='md:absolute md:right-[80%] md:top-[170px] lg:right-[60%] lg:top-[240px] xl:top-[270px]  w-full flex items-center justify-center mb-[-40px] transform transition-all ease-in-out duration-300'>
                  <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[30px]  px-[12px] h-[30px]">
                    <img src={errorIcon} alt="" className=" size-[14px]" />
                    <p className=" font-normal text-[#EB0728] text-[10px] leading-[12.13px]">
                      {searchError}
                    </p>
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          {/* 
          {/**Error Display */}
          {/* {searchError !== "" ? (
            <div className='w-full flex items-center justify-center mb-[-40px] transform transition-all ease-in-out duration-300'>
              <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border border-[#EB0728] px-[12px] py-[3px]">
                <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
                <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
                  {searchError}
                </p>
              </div>
            </div>
          ) : null}  */}

          {/* Large Screen Search */}
          <div className='absolute  px-4 md:px-8 mg:px-[64px]   md:top-[356px] lg:top-[456px] xl:top-[470px] w-full hidden md:flex items-center justify-center self-center md:justify-start z-[40]'>
            <div className='w-full md:max-w-[60%] lg:max-w-[60%] flex justify-between '>
              <div className={`w-full flex items-center rounded-l-[80px] shadow-search  border ${searchError === 'Invalid Search' ? ' border-2 border-[#EB0728]' : 'border-[#C1C1C180] '} bg-white transform transition-all ease-in-out duration-300`}>
                <CountrySelector page='home' searchError={searchError} setSearchError={setSearchError} vendorCountryData={filteredCountries} handleCountrySelect={handleCountrySelect} device="large" />
                <div className='border border-[1.5px] h-[25px] bg-[#C1C1C1]' />
                <CategorySelector page='home' searchError={searchError} setSearchError={setSearchError} categoryData={filteredCategories} handleCategorySelect={handleCategorySelect} device="large" />
                <div className='border border-[1.5px] h-[25px] bg-[#C1C1C1]' />
                <VendorSelector page='home' searchError={searchError} setSearchError={setSearchError} vendorData={filteredVendors} handleVendorSelect={handleVendorSelect} device="large" />
              </div>
              <button onClick={() => handleSearch()} className='w-full max-w-[52px] h-[45px] lg:h-[52px] rounded-r-[80px] flex items-center justify-center bg-[#0079FF] hover:opacity-70 transform transition-all ease-in-out duration-300'>
                <img src={search_icon} alt="search_icon" className='w-[18.75px] h-[18.75px]' />
              </button>
            </div>
          </div>

          {/**Small Screen Search */}
          <div className='w-full absolute  top-[326px] flex md:hidden flex-col gap-[10px] px-[32px] '>
            <CountrySelector page='home' searchError={searchError} setSearchError={setSearchError} vendorCountryData={filteredCountries} handleCountrySelect={handleCountrySelect} device="small" />
            <CategorySelector page='home' searchError={searchError} setSearchError={setSearchError} categoryData={filteredCategories} handleCategorySelect={handleCategorySelect} device="small" />
            <div className='w-full flex'>
              <VendorSelector page='home' searchError={searchError} setSearchError={setSearchError} vendorData={filteredVendors} handleVendorSelect={handleVendorSelect} device="small" />
              <button onClick={() => handleSearch()} className=' z-20 relative w-full max-w-[52px] h-[45px] lg:h-[52px] rounded-r-[80px] flex items-center justify-center bg-[#0079FF] hover:opacity-70 transform transition-all ease-in-out duration-300'><img src={search_icon} alt="search_icon" className=' w-[18.75px] h-[18.75px]' /></button>
            </div>
          </div>
        </div>
      </div>
      <div className='w-full relative'>
        {/**Recent reviews */}
        <div className=' w-full -mt-[55px]  xl:-mt-[250px] rounded-t-[50px] md:rounded-t-[40px] lg:rounded-t-[50px] pt-[37px] md:pt-[32px] px-[24px] md:px-[32px] xl:px-[64px] bg-white z-[10]'>
          <div className=' w-full flex items-center justify-center mb-[39px] md:mb-[45px] lg:mb-[75px] xl:mb-[96px]'>
            <HowToRate />
          </div>
          {/* <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4893293628988130"
            crossorigin="anonymous"></script>
          <ins class="adsbygoogle"
            style="display:block"
            data-ad-format="fluid"
            data-ad-layout-key="-fb+5w+4e-db+86"
            data-ad-client="ca-pub-4893293628988130"
            data-ad-slot="1949276411"></ins>
          <script>
            (adsbygoogle = window.adsbygoogle || []).push({ });
          </script> */}

          <h1 className=' font-bold text-[18px] md:text-[25px]'>Recent reviews</h1>
          <div className='grid grid-cols-[repeat(auto-fill,_minmax(327px,_1fr))] lg:grid-cols-[repeat(auto-fill,_minmax(310px,_1fr))] xl:grid-cols-[repeat(auto-fill,_minmax(426px,_1fr))] mt-[33px] md:mt-[27px] w-full flex flex-wrap gap-[30px] md:gap-[24px] lg:gap-x-[15px] xl:gap-x-[16px] gap-y-[30px] md:gap-y-[40px] lg:gap-y-[36px] xl:gap-y-[60px]'>

          {displayedReviews && displayedReviews.length > 0 ? (
  displayedReviews
    .sort((a, b) => b.feedback_id - a.feedback_id) // keep sorting
    .map((item, index) => (
      <Review key={index} item={item} setCreateAccount={setCreateAccount} />
    ))
) : null}

          </div>
          {!hasShownMore && reviewData.length > perPage && (
  <div className="flex justify-center mt-8">
    <button
      onClick={() => { setHasShownMore(true); setShowPagination(true); setCurrentPage(2);}}
      className="px-6 py-3 bg-white border-ravblue border text-ravblue rounded-[80px] font-bold hover:opacity-70 transition"> Show More </button>
  </div>
)}

       {showPagination && reviewData.length > perPage && (
  <div className=" flex items-center justify-center gap-0 mt-8 bg-[#E5E5E5]/50 rounded-[80px] h-[45px] w-fit px-1 mx-auto">
  {/* Prev button */}
  <button
    disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)} className={`flex items-center gap-[3px] pl-4 pr-[19px] py-2 text-nowrap font-medium text-[14px] text-black  ${currentPage === 1 ? 'cursor-not-allowed' : "" } transition`}> <ChevronLeft size={20}/> <span>Prev</span></button>
  {/* Page numbers */}
<div className="bg-white rounded-[10px] w-fit px-2 border flex items-center h-[35px]">
  {(() => {
    const totalPages = Math.ceil(reviewData.length / perPage);
    const windowSize = 5;
    const windowStart = Math.floor((currentPage - 1) / windowSize) * windowSize;
    return Array.from(
      { length: Math.min(windowSize, totalPages - windowStart) },
      (_, i) => {
        const page = windowStart + i + 1;
        return (
          <button key={page} onClick={() => setCurrentPage(page)} className={`gap-0 mx-auto py-[5px] items-center justify-center w-[27px] flex h-[24px] rounded-[6px] font-medium text-[14px] transition ${currentPage === page ? "bg-ravblue text-white" : "text-black hover:bg-gray-100"}`}
          >
            {page}
          </button>
        );
      }
    );
  })()}
</div>
  {/* Next button */}
  <button disabled={currentPage === Math.ceil(reviewData.length / perPage)} onClick={() => setCurrentPage(prev => prev + 1)} className={`flex px-4 font-medium text-black text-[14px] py-2 ${currentPage === Math.ceil(reviewData.length / perPage) ? ' cursor-not-allowed' : ""} transition`}> <span>Next</span> <ChevronRight size={20}/></button>
  </div>
)}
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default Home
